import React from 'react';

import { Container } from './styles';

const Footer: React.FC = () => {
  return (
    <Container>
      <p>
        Made by <a href='https://github.com/diogofalken'>Diogo</a>
      </p>
    </Container>
  );
};

export default Footer;
